import { QueryKeysEnum } from '@/enums';
import {
  CreateIncidentAlertLoggerParam,
  IncidentAlertLoggerEntity,
} from '@/types';
import { BaseService } from './base.service';

class IncidentAlertLoggerService extends BaseService<
  'incidentAlertLogger',
  IncidentAlertLoggerEntity,
  CreateIncidentAlertLoggerParam
> {
  constructor() {
    super(QueryKeysEnum.INCIDENT_ALERT_LOGGER);
  }
}

export const incidentAlertLoggerService = new IncidentAlertLoggerService();
